import { ACCESS_COOKIE_NAME } from '@pequity/shared/types/constants';

const ACCESS_TOKEN_KEY = 'access_token';

export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const setAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  document.cookie = `${ACCESS_COOKIE_NAME}=Bearer ${token}; path=/;`;
};

export const tokenExpired = (token: string): boolean => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiresAtMs = payload.exp * 1000 - 15000;
    return expiresAtMs < Date.now();
  } catch {
    return true;
  }
};

export const hasValidToken = (): boolean => {
  const token = getAccessToken();
  return !!token && !tokenExpired(token);
};
